var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-icon",class:{'loading-icon--expand': _vm.expand},style:({ '--colour1': _vm.colour1, '--colour2': _vm.colour2, '--scale': _vm.scale, 'max-height': _vm.maxHeight})},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-wrapper-outer"},[_c('div',{staticClass:"circle-wrapper"},[_c('div',{staticClass:"circle1"}),_c('div',{staticClass:"circle2"})])])
}]

export { render, staticRenderFns }